module.exports = __webpack_public_path__ + "static/media/sofit.ded191ef.png";